import authServiceSagas from 'modules/auth/services/sagas';
import channelServiceSagas from 'modules/channel/services/sagas';
import dashboardServiceSagas from 'modules/dashboard/services/sagas';
import mediaServiceSagas from 'modules/media/services/sagas';
import storeServiceSagas from 'modules/store/services/sagas';
import playlistServiceSagas from 'modules/playlist/services/sagas';

import { all, fork } from 'redux-saga/effects';

export default function* rootSaga() {
  yield all([
    fork(authServiceSagas),
    fork(dashboardServiceSagas),
    fork(channelServiceSagas),
    fork(mediaServiceSagas),
    fork(storeServiceSagas),
    fork(playlistServiceSagas),
  ]);
}
